export const NO_RESULTS = "No survey results";
export const NO_COACH_SELECTED = "No teacher selected";
export const NO_COACH_SELECTED_AD = "No school admin selected";


// WEBPACK FOOTER //
// ./src/pages/director/SurveyDataCenter/utils/getHeaderText/constants.ts